import { Text } from "@mantine/core";
import type { ReactNode } from "react";

export const TinyText = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  return (
    <Text c={"dimmed"} size="xs">
      {children}
    </Text>
  );
};
